import React, { useState, useEffect, useCallback } from "react";
import {
  Typography,
  Divider,
  Button,
  TextField,
  Grid,
  FormGroup,
  FormControlLabel,
  InputAdornment,
} from "@mui/material";
import useStyles from "./style";
import CustomSwitch from "SharedComponents/CustomSwitch";
import { useFormik } from "formik";
import * as yup from "yup";
import settingsApi from "Services/Settings";
import ImageUploadApi from "Services/ImageUpload";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { setNewSiteLogo } from "Redux/SiteSettings/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";

//
import { CUSTOM_CONSTANTS } from "../../../Constants";

import DropZone from "./DropZone";

const Settings = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [appState, setAppState] = useState(true);
  const [smsState, setSmsState] = useState(true);
  const [values, setValues] = useState(null);
  const [siteLogo, setSiteLogo] = useState("");

 // const [showIosDriverMapKey, setShowIosDriverMapKey] = useState(false);

  // Save or Edit profile details
  const handleSettings = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    const data = {
      siteName: formValues?.siteName,
      copyRightContent: formValues?.copyRightContent,
      playStoreLink: formValues?.playStoreLink,
      appStoreLink: formValues?.appStoreLink,
      sosNumber: formValues?.sosNumber,
      contactNumber: formValues?.contactNumber,
      contactEmail: formValues?.contactEmail,
      driverAppversion: formValues?.driverAppversion,
      userAppversion : formValues?.userAppversion,
      AndroiduserAppversion : formValues?.AndroiduserAppversion,
      AndroiddriverAppversion : formValues?.AndroiddriverAppversion,
     
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Updated site settings successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik?.resetForm();
        setValues(null);
        getMasterValues();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while update site settings",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("settings value update api", err);
    };
    settingsApi.updateMasterValues({ ...data }).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      siteName: "",
      copyRightContent: "",
      playStoreLink: "",
      appStoreLink: "",
      sosNumber: "",
      contactNumber: "",
      contactEmail: "",
      driverAppversion: '',
      userAppversion: '',
      AndroiduserAppversion: '',
      AndroiddriverAppversion: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      siteName: yup.string().required("Site Name is required").nullable(),
    driverAppversion: yup
    .string()
    .required("Driver app version is required")
    .matches(/^\d+(\.\d+)?$/, "Only numeric versions like 3.0 or 3.6 are allowed")
    .nullable(),
    userAppversion: yup
    .string()
    .required("User app version is required")
    .matches(/^\d+(\.\d+)?$/, "Only numeric versions like 3.0 or 3.6 are allowed")
    .nullable(),      
      contactNumber: yup
        .string()
        .required("Contact Number is required")
        .matches(/^[0-9]+$/, "Only Numbers are allowed")
        .max(10, `Max 10 digits are allowed`)
        .min(10, `Must be exactly 10 numbers`)
        .nullable(),
      contactEmail: yup
        .string()
        .email("Enter a valid Email Address")
        .nullable(),
      sosNumber: yup.string().matches(/^[0-9]+$/, "Only Numbers are allowed"),
    }),
    onSubmit: handleSettings,
  });

  // Get Master Values
  const getMasterValues = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setValues(res?.data?.data);
      } else {
        setValues([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getMasterValues().then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getMasterValues();
  }, [getMasterValues]);

  // Set fetched values for master
  useEffect(() => {
    if (!_.isEmpty(values)) {
      formik.setFieldValue("siteName", values?.siteName);
      formik.setFieldValue("copyRightContent", values?.copyRightContent);
      formik.setFieldValue("siteName", values?.siteName);
      formik.setFieldValue("copyRightContent", values?.copyRightContent);
      formik.setFieldValue("playStoreLink", values?.playStoreLink);
      formik.setFieldValue("appStoreLink", values?.appStoreLink);
      formik.setFieldValue("sosNumber", values?.sosNumber);
      formik.setFieldValue("contactNumber", values?.contactNumber);
      formik.setFieldValue("contactEmail", values?.contactEmail);
      formik.setFieldValue("userAppversion", values?.userAppversion);
      formik.setFieldValue("driverAppversion", values?.driverAppversion);            
      formik.setFieldValue("AndroiddriverAppversion", values?.AndroiddriverAppversion);            
      formik.setFieldValue("AndroiduserAppversion", values?.AndroiduserAppversion);            
      setSiteLogo(values?.siteLogo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  // upload site logo

  const [uploadSiteLogoErros, setUploadSiteLogoErros] = useState([]);
  const [uploadErros, setUploadErros] = useState([]);
  const [saveLogoImage, setSaveLogoImage] = useState("");

  const uploadSiteLogo = (acceptedFiles) => {
    dispatch(showLoader("Loading please wait..."));
   // console.log('acceptedFiles-->',acceptedFiles);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Site logo updated successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
          //Set Site Logo
              dispatch(
                setNewSiteLogo(res?.data?.data?.siteLogo)
              );
        
              localStorage.setItem(
                "siteLogo",
                res?.data?.data?.siteLogo
              );
        
        setUploadSiteLogoErros([]);
        // console.log('res?.data-->',res?.data);
        setSaveLogoImage(res?.data?.data?.siteLogo);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      showSnackbar({
        message: err?.data?.msg || "Error while update the site logo",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    };
    const formData = new FormData();
    acceptedFiles?.map((file) => formData.append("image", file));
    settingsApi.sitelogoupload(formData).then(onSuccess, onFailure);
  };

  return (
    <>
      <br></br>
      <br></br>
      <Grid container className={classes.cardContainer}>
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <div style={{ padding: "15px" }}>
            <Typography variant="h5">Site Logo</Typography>
          </div>
          <div
            className={classes.fieldContainer}
            style={{
              border: "1px solid #dedede",
              margin: "10px",
              borderRadius: "8px",
              padding: "30px",
            }}
          >
            <DropZone upload={uploadSiteLogo} setUploadErros={setUploadErros} />
          </div>
          <div style={{ padding: "15px" }}>
            {!_.isEmpty(uploadErros) && (
              <Grid item xs={12} style={{ paddingBlock: 12 }}>
                {uploadErros.map(({ file, errors }) => (
                  <div key={file.path}>
                    {errors?.map((e) => (
                      <Typography
                        style={{ color: "red" }}
                        variant="caption"
                        key={e.code}
                      >
                        {e.message}
                      </Typography>
                    ))}
                  </div>
                ))}
              </Grid>
            )}
            <Typography variant="h5">Preview</Typography>
            {saveLogoImage ? (
              <img
                src={saveLogoImage}
                alt="site logo"
                className={classes.siteLogo}
              />
            ) : siteLogo !== "" ? (
              <img
                src={siteLogo}
                alt="site logo"
                className={classes.siteLogo}
              />
            ) : (
              <img
                src="/assets/images/logos/no-image.png"
                alt="site logo"
                className={classes.siteLogo}
              />
            )}
          </div>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <Grid container className={classes.cardContainer}>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          xl={12}
          className={classes.container}
        >
          <div style={{ padding: "15px" }}>
            <Typography variant="h5">General Settings</Typography>
          </div>
        </Grid>

        <Grid item xs={12} md={6} lg={6} xl={6} className={classes.container}>
          {/* Site Name */}
          <div className={classes.fieldWrapper}>
            <Grid item xs={12} md={6} lg={12} xl={12}>
              <TextField
                name="siteName"
                id="siteName"
                value={formik?.values?.siteName}
                onChange={formik?.handleChange}
                type={"text"}
                fullWidth
                variant="outlined"
                size="small"
                label="Site Name*"
                error={formik?.errors?.siteName && formik?.touched?.siteName}
                helperText={
                  formik?.errors?.siteName &&
                  formik?.touched?.siteName &&
                  formik?.errors?.siteName
                }
              />
            </Grid>
          </div>

          {/* Copyrights Content */}
          <Grid
            item
            xs={12}
            md={6}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
            <TextField
              name="copyRightContent"
              id="copyRightContent"
              value={formik?.values?.copyRightContent}
              onChange={formik?.handleChange}
              type={"text"}
              fullWidth
              variant="outlined"
              size="small"
              label="Copyright Content"
              error={
                formik?.errors?.copyRightContent &&
                formik?.touched?.copyRightContent
              }
              helperText={
                formik?.errors?.copyRightContent &&
                formik?.touched?.copyRightContent &&
                formik?.errors?.copyRightContent
              }
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
            <TextField
              name="playStoreLink"
              id="playStoreLink"
              value={formik?.values?.playStoreLink}
              onChange={formik?.handleChange}
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              label="Playstore Link"
              error={
                formik?.errors?.playStoreLink && formik?.touched?.playStoreLink
              }
              helperText={
                formik?.errors?.playStoreLink &&
                formik?.touched?.playStoreLink &&
                formik?.errors?.playStoreLink
              }
            />
          </Grid>

          {/* Appstore Link */}
          <Grid
            item
            xs={12}
            md={6}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
            <TextField
              name="appStoreLink"
              id="appStoreLink"
              value={formik?.values?.appStoreLink}
              onChange={formik?.handleChange}
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              label="Appstore Link"
              error={
                formik?.errors?.appStoreLink && formik?.touched?.appStoreLink
              }
              helperText={
                formik?.errors?.appStoreLink &&
                formik?.touched?.appStoreLink &&
                formik?.errors?.appStoreLink
              }
            />
          </Grid>

          {/* SOS Number */}
          <Grid
            item
            xs={12}
            md={6}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
            <TextField
              name="sosNumber"
              id="sosNumber"
              value={formik?.values?.sosNumber}
              onChange={formik?.handleChange}
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              label="SOS Number"
              error={formik?.errors?.sosNumber && formik?.touched?.sosNumber}
              helperText={
                formik?.errors?.sosNumber &&
                formik?.touched?.sosNumber &&
                formik?.errors?.sosNumber
              }
            />
          </Grid>

        </Grid>

        <Grid item xs={12} md={6} lg={6} xl={6} className={classes.container}>

         {/* Driver app version */}
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
            <TextField
              name="driverAppversion"
              id="driverAppversion"
              value={formik?.values?.driverAppversion}
              onChange={formik?.handleChange}
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              label="Driver App Version"
              error={
                formik?.errors?.driverAppversion && formik?.touched?.driverAppversion
              }
              helperText={
                formik?.errors?.driverAppversion &&
                formik?.touched?.driverAppversion &&
                formik?.errors?.driverAppversion
              }
            />
          </Grid>

         {/* User app version */}
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
            <TextField
              name="userAppversion"
              id="userAppversion"
              value={formik?.values?.userAppversion}
              onChange={formik?.handleChange}
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              label="User App Version"
              error={
                formik?.errors?.userAppversion && formik?.touched?.userAppversion
              }
              helperText={
                formik?.errors?.userAppversion &&
                formik?.touched?.userAppversion &&
                formik?.errors?.userAppversion
              }
            />
          </Grid>

         {/* Contact Number */}
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
            <TextField
              name="contactNumber"
              id="contactNumber"
              value={formik?.values?.contactNumber}
              onChange={formik?.handleChange}
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              label="Contact Number"
              error={
                formik?.errors?.contactNumber && formik?.touched?.contactNumber
              }
              helperText={
                formik?.errors?.contactNumber &&
                formik?.touched?.contactNumber &&
                formik?.errors?.contactNumber
              }
            />
          </Grid>

          {/* Contact Email */}
          <Grid
            item
            xs={12}
            md={6}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
            <TextField
              name="contactEmail"
              id="contactEmail"
              value={formik?.values?.contactEmail}
              onChange={formik?.handleChange}
              type="email"
              fullWidth
              variant="outlined"
              size="small"
              label="Contact Email"
              error={
                formik?.errors?.contactEmail && formik?.touched?.contactEmail
              }
              helperText={
                formik?.errors?.contactEmail &&
                formik?.touched?.contactEmail &&
                formik?.errors?.contactEmail
              }
            />

              <Grid
            item
            xs={12}
            md={6}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
             <TextField
              name="AndroiduserAppversion"
              id="AndroiduserAppversion"
              value={formik?.values?.AndroiduserAppversion}
              onChange={formik?.handleChange}
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              label="User Andriod App Version"
              error={
                formik?.errors?.AndroiduserAppversion && formik?.touched?.AndroiduserAppversion
              }
              helperText={
                formik?.errors?.AndroiduserAppversion &&
                formik?.touched?.AndroiduserAppversion &&
                formik?.errors?.AndroiduserAppversion
              }
            />

</Grid>
     <Grid
            item
            xs={12}
            md={6}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
             <TextField
              name="AndroiddriverAppversion"
              id="AndroiddriverAppversion"
              value={formik?.values?.AndroiddriverAppversion}
              onChange={formik?.handleChange}
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              label="Driver Andriod App Version"
              error={
                formik?.errors?.AndroiddriverAppversion && formik?.touched?.AndroiddriverAppversion
              }
              helperText={
                formik?.errors?.AndroiddriverAppversion &&
                formik?.touched?.AndroiddriverAppversion &&
                formik?.errors?.AndroiddriverAppversion
              }
            />
            </Grid>
          </Grid>

{/* IOS Driver Map Key */}
{/* <Grid
item
xs={12}
md={6}
lg={12}
xl={12}
className={classes.fieldWrapper}
>
<TextField
  name="iosDriverMapKey"
  id="iosDriverMapKey"
  value={formik?.values?.iosDriverMapKey}
  onChange={formik?.handleChange}
  type={showIosDriverMapKey ? "text" : "password"}
  fullWidth
  variant="outlined"
  size="small"
  label="IOS Driver Map Key"
  error={
    formik?.errors?.iosDriverMapKey &&
    formik?.touched?.iosDriverMapKey
  }
  helperText={
    formik?.errors?.iosDriverMapKey &&
    formik?.touched?.iosDriverMapKey &&
    formik?.errors?.iosDriverMapKey
  }
  InputProps={{
    endAdornment: (
      <InputAdornment position="end" className={classes.password}>
        {showIosDriverMapKey ? (
          <VisibilityIcon
            onClick={() => setShowIosDriverMapKey(false)}
          />
        ) : (
          <VisibilityOffIcon
            onClick={() => setShowIosDriverMapKey(true)}
          />
        )}
      </InputAdornment>
    ),
  }}
/>
</Grid> */}

        </Grid>
        <Grid item xs={12} md={6} lg={12} xl={12} className={classes.btn}>
          <Button variant="contained" onClick={formik.handleSubmit}>
            Update
          </Button>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <br></br>
    </>
  );
};

export default Settings;
